import { paths } from "../../../shared/configs/paths";
import { CampaignDetails } from "../types";
import { extractDomain } from "../../../shared/libs/extract-domain";
import { transposeMatrix } from "../../../shared/libs/transpose-matrix";

const baseUrl = window.__ENV__.VITE_BASE_URL ?? import.meta.env.VITE_BASE_URL;

export const exportCampaignReportToCsv = async (data: CampaignDetails) => {
  if (!data.tasks) return console.error("No data to export");

  const tasks = data.tasks || [];
  const statistics = data.statistics;

  const minSimilarities = statistics.minSimilarity;
  const maxSimilarities = statistics.maxSimilarity;
  const avgSimilarities = statistics.avgSimilarity;
  const topDomains = statistics.topDomains;

  const launchDate = new Date(data.createdAt).toLocaleDateString();

  const campaignInfo = [
    ["Campaign Information"],
    ["Name", "Category", "CreatedAt", "Initiator"],
    [data.name, data.category, launchDate, data.createdByEmail],
    [""],
  ];

  const statisticsData = [
    ["Statistics"],
    ["Min Similarities", "Avg Similarities", "Max Similarities", "Top Domains"],
    [minSimilarities, avgSimilarities, maxSimilarities, topDomains],
    [""],
  ];

  const articlesHeader = [
    ["Articles"],
    ["URL", "Publication Date", "Similarities Count", "Full Report Link"],
  ];

  const articleRows = tasks.map((task) => [
    task.originalUrl,
    task.date ? new Date(task.date).toISOString().split("T")[0] : "-",
    task.similaritiesCount,
    `${baseUrl}${paths.articleDetails.replace(":id", task.id)}`,
  ]);

  const similarUrls = [
    [""],
    ["All Domains", ""].concat(tasks.flatMap(t => [t.originalUrl, ''])),
  ]

  const pattern = '=XLOOKUP(INDIRECT("RC[1]",FALSE), DATA!$C$2:$C$3000, DATA!$B$2:$B$3000, "-//-", 0)';
  const uniqueAllDomains = [...new Set(tasks.flatMap((task) => (task.similaritiesUrls))
    .map((u) => extractDomain(u)))];
  const similarUrlsRows = tasks.flatMap(t => [Array(t.similaritiesUrls.length).fill(pattern), t.similaritiesUrls.map(u => extractDomain(u))]);
  const transposedTimilarUrlsRows = transposeMatrix([uniqueAllDomains].concat(similarUrlsRows));
 
  const csvContent = [
    ...campaignInfo,
    ...statisticsData,
    ...articlesHeader,
    ...articleRows,
    ...similarUrls,
    ...transposedTimilarUrlsRows,
  ]
    .map((row) =>
      row.map((value) => `"${String(value).replace(/"/g, '""')}"`).join(",")
    )
    .join("\n");

  const blob = new Blob([csvContent], {
    type: "text/csv;charset=utf-8;",
  });

  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute(
    "download",
    `${data.name.replace(/[^a-zA-Z0-9]/g, "_")}_export.csv`
  );

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};
